export default "https://cdn-static.gokick.com/assets/c0e4f86ff5da21e4b09546702d214e718bb56dad/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";